import useFetch from 'hooks/useFetch'

import { Box, Card, Divider, Typography } from '@material-ui/core'
import { Container, ContentHeader, LoadingBox, Page } from 'components'
import { CompanyServicesForm } from './components'

import * as service from 'service'

const CompanyServicesEdit = ({ match }) => {
  const { companyServiceId } = match.params

  const { response, isLoading } = useFetch(
    service.marketPlace.companyService.get,
    {
      companyServiceId,
    },
  )

  return (
    <Page title="Alterar serviço de empresa">
      <Container
        maxWidth={false}
        spacingXl={50}
        spacingLg={25}
        spacingMd={10}
        spacingSm={10}
      >
        <ContentHeader
          menu="Gerenciamento"
          title="Serviços da empresa"
          subtitle="Alterar serviço de empresa"
        />
        <Card>
          <Box p={2}>
            <Typography variant="h5">Alterar um serviço de empresa</Typography>
          </Box>
          <Divider />
          <Box mt={3}>
            {isLoading ? (
              <LoadingBox />
            ) : (
              <CompanyServicesForm
                companyServiceId={companyServiceId}
                companyService={response?.data?.companyService}
              />
            )}
          </Box>
        </Card>
      </Container>
    </Page>
  )
}

export default CompanyServicesEdit
